var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C14.416 18 18 14.416 18 10C18 5.584 14.416 2 10 2C5.584 2 2 5.584 2 10C2 14.416 5.584 18 10 18ZM9.2 6L10.8 6L10.8 10.8L9.2 10.8L9.2 6ZM9.2 12.4L10.8 12.4L10.8 14L9.2 14L9.2 12.4Z",
    fill: "#E0482D",
    fillOpacity: 0.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.b79ecb3224e97f21be467114138e42b0.svg";
export { ForwardRef as ReactComponent };